import React from 'react';

const Footer = () => {
  const handleEmailClick = () => {
    let hasBlurred = false;
    const onBlur = () => { hasBlurred = true; };
    window.addEventListener('blur', onBlur);

    setTimeout(() => {
      window.removeEventListener('blur', onBlur);
      if (!hasBlurred) {
        const email = 'hello@ssrrlabs.com';
        const subject = encodeURIComponent('Project Inquiry - SSRR Labs');
        const body = encodeURIComponent('Hi SSRR Labs team,\n\nI would like to discuss a potential project with you.\n\nBest regards,');
        window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`, '_blank', 'noopener,noreferrer');
      }
    }, 600);
  };

  return (
    <footer>
      <div className="ft">
        <div className="ft-top">
          <div className="ft-brand">
            <a href="/" className="ft-logo">
              <div className="logo-sq">SR</div>
              <span className="ft-name">SSRR <b>Labs</b></span>
            </a>
            <p className="ft-about">
              AI-powered products, technology services and strategic
              consulting across finance, e-commerce, banking and
              human-centric applications. Built for everyone.
            </p>
            <a href="mailto:hello@ssrrlabs.com?subject=Project%20Inquiry%20-%20SSRR%20Labs&body=Hi%20SSRR%20Labs%20team,%0A%0AI%20would%20like%20to%20discuss%20a%20potential%20project%20with%20you." onClick={handleEmailClick} className="ft-email">hello@ssrrlabs.com</a>
          </div>

          <div>
            <div className="ft-col-title">Expertise</div>
            <ul className="ft-links">
              <li><a href="/">Financial Technology</a></li>
              <li><a href="/">E-Commerce & Retail</a></li>
              <li><a href="/">Banking & Payments</a></li>
              <li><a href="/">Human-Centric Apps</a></li>
              <li><a href="/">Enterprise SaaS</a></li>
            </ul>
          </div>

          <div>
            <div className="ft-col-title">Services</div>
            <ul className="ft-links">
              <li><a href="/">AI SaaS Products</a></li>
              <li><a href="/">Custom Development</a></li>
              <li><a href="/">AI Consulting</a></li>
              <li><a href="/">Cloud Architecture</a></li>
              <li><a href="/">Product Strategy</a></li>
            </ul>
          </div>

          <div>
            <div className="ft-col-title">Company</div>
            <ul className="ft-links">
              <li><a href="/">About SSRR Labs</a></li>
              <li><a href="/">How We Work</a></li>
              <li><a href="/">Careers</a></li>
              <li><a href="/">Privacy Policy</a></li>
              <li><a href="/">Terms of Service</a></li>
            </ul>
          </div>
        </div>

        <div className="ft-bottom">
          <div className="ft-copy">© 2026 SSRR Labs Inc. All rights reserved.</div>
          <div className="ft-mark"><span>S</span> · <span>S</span> · <span>R</span> · <span>R</span></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;